import React from 'react'
import CallToAction from 'components/MainNav/Submenus/CallToAction'
import { LinkedinIcon } from 'components/LinkedinIcon'
import { LinkedIn } from 'components/Icons/Icons'
import { GatsbyImage, getImage, ImageDataLike, StaticImage } from 'gatsby-plugin-image'
import Link from 'components/Link'
import { prepareData } from 'utils/googleData'

export const AboutStory = (props) => {
    const { enable, story, subtitle, description, cta, cta2, svgImage, gatsbyImage, gatsbyImage2, imageStyles } =
        prepareData({
            props,
        })
    if ((enable === false || enable?.toLowerCase?.() === 'false') && !process.env.RENDER_DISABLED_COMPONENTS) {
        return <></>
    }
    return (
        <section id="story" className="mx-auto flex max-w-screen-xl flex-col px-4 md:flex-row md:pl-8 md:pr-6">
            <div className="flex flex-1 flex-col justify-between">
                <div>
                    <h2 className="text-4xl">{story?.title}</h2>
                    <h4>{story?.subtitle}</h4>
                    {story?.description}
                    <br />
                    <br />
                    <CallToAction to={cta[0]?.url} className="w-full mdlg:w-auto">
                        {cta[0]?.name}
                    </CallToAction>
                </div>
                <div className="mt-6 inline-flex items-center gap-8 border-t border-dashed  border-gray-accent-light pt-3 pb-5 sm:mr-12 sm:flex-col sm:items-start sm:gap-2 mdlg:mr-24 mdlg:flex-row mdlg:items-center mdlg:gap-8">
                    <p className="mb-0 pb-0 text-sm opacity-75">{cta[1]?.name}</p>
                    <span className="h-[28px] w-[125px]">
                        <LinkedinIcon companyname={cta[1]?.url} />
                    </span>
                    {/* <Link  to={cta[1]?.url}>
                        <span className="fill-current">
                            <LinkedIn className="box-border h-8 w-8" />
                        </span>
                    </Link> */}
                </div>
            </div>
            <aside className="relative shrink-0 grow-0 lg:basis-[calc(730px-4rem)]">
                <div className="hidden justify-end md:flex"></div>
                {gatsbyImage2 && (
                    <div className="relative flex justify-end">
                        <GatsbyImage
                            image={gatsbyImage2}
                            width={620}
                            height={397.5}
                            alt="iCloudReady launches"
                            objectFit="contain"
                            className="-mx-4 -mb-8 box-border rotate-2 md:-right-4 md:mx-0 md:-mb-4 md:h-full md:w-[500px] lg:right-0 lg:h-auto lg:w-auto"
                        />

                        <div className="md:top-4em absolute bottom-0 h-[60%] w-full bg-gradient-to-b from-transparent to-tan md:h-full lg:top-[initial] lg:h-[60%]" />
                    </div>
                )}
                {gatsbyImage && (
                    <div className="absolute bottom-0 right-4 md:right-4 lg:-bottom-2 lg:right-8">
                        <GatsbyImage
                            breakpoints={[750, 1080, 1366, 1920]}
                            image={gatsbyImage}
                            width={385.5}
                            height={366}
                            quality={100}
                            alt="Ahmed Elazab, CEO, Founder"
                            placeholder="none"
                            objectFit="contain"
                            className="w-[50vw] md:w-[300px] lg:w-auto"
                        />
                    </div>
                )}
            </aside>
        </section>
    )
}
